/**
 * Set the steel (color) selection
 *
 */

define('libs/steelselector',[],function() {

    'use strict';

    var SETTINGS = {
        steelSelector: '.steel',
        selectedSteelSelector: '#selected-staal',
        selectedSteelNumberSelector: '.staal-content',
        selectedSteelBackgroundSelector: '.staal',
        mainImageSelector: '.digistudio-image',
        mainImageColorSelector: '.digistudio-color',
        selectorNumberSelector: '.selector-steel-number',
        selectorImageSelector: '.selector-steel-image'
    };

    var SteelSelector = function(root, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.$root = $(root);

        this.$root.on('click', this.settings.steelSelector, this.onSelect.bind(this));
    };

    SteelSelector.prototype.onSelect = function(event) {
        event.preventDefault();
        var data = {
                color: event.currentTarget.getAttribute('data-color'),
                number: event.currentTarget.getAttribute('data-number'),
                img: event.currentTarget.getAttribute('href'),
                steelImage: $(event.currentTarget).find('img').attr('src')
            };

        try {
            $.extend(data, {extended: $(event.currentTarget).data('json')});
        } catch(e) {
            console.log('failed to parse steel data attribute', e);
        }


        this.selectedSteel = this.selectedSteel || {
            root: $(this.settings.selectedSteelSelector),
            number: $(this.settings.selectedSteelSelector + ' ' + this.settings.selectedSteelNumberSelector),
            background: $(this.settings.selectedSteelSelector + ' ' + this.settings.selectedSteelBackgroundSelector),
            mainImage: $(this.settings.mainImageSelector),
            mainImageColor: $(this.settings.mainImageColorSelector),
            selectorNumber: $(this.settings.selectorNumberSelector),
            selectorImage: $(this.settings.selectorImageSelector)
        };

        this.setSelection(data);
    };

    SteelSelector.prototype.setSelection = function(data) {
        this.selectedSteel.number.html(data.number);
        if (data.color) {
            this.selectedSteel.background.css('background-color', data.color);
            this.selectedSteel.background.css('background-image', '');
        } else {
            this.selectedSteel.background.css('background-image', 'url(' + data.steelImage + ')');
            this.selectedSteel.background.css('background-color', '');
        }


        // set the rest of the steel properties.
        for (var prop in data.extended) {
            if (data.extended[prop]) {
                var node = $('#' + prop + ' .property-value');
                if (node.length) {
                    node.html(data.extended[prop]);
                }
            }
        }

        this.selectedSteel.mainImageColor.css('background-color', data.color || '');
        this.selectedSteel.mainImage.css('background-image', data.color ? '' : 'url(' + data.steelImage + ')');
        this.selectedSteel.selectorNumber.html(data.number);
        this.selectedSteel.selectorImage.attr('src', data.steelImage);
    };


    return SteelSelector;
});

